import { defineMessages } from "react-intl";

export default defineMessages({
  paymentConfirmed: {
    id: "subscribe.paymentConfirmed",
    defaultMessage: "Payment confirmed",
  },
  waitingForBankTransfer: {
    id: "subscribe.waitingForBankTransfer",
    defaultMessage: "Waiting for bank transfer",
  },
  yourSubscriptionIsActivated: {
    id: "subscribe.yourSubscriptionIsActivated",
    defaultMessage: "Your <bold>subscription</bold><plus></plus> is activated!",
  },
  continue: {
    id: "subscribe.continue",
    defaultMessage: "Continue",
  },
});
